import React from 'react';
import { Create } from 'react-admin';
import { withStyles } from '@material-ui/core/styles';
import { FormSpy } from 'react-final-form';
import moment from 'moment';

import NavigationPrompt from '../../core/components/NavigationPrompt';
import CreateToolbar from '../../core/components/CreateToolbar';
import FormTitleBar from '../../core/components/FormTitleBar';
import MailTemplateSummary from './MailTemplateSummary';
import LeaveConfirm from '../../core/components/LeaveConfirmWrapper';
import CustomSimpleForm from '../../core/components/form/CustomSimpleForm';

const styles = () => ({
  noActions: {
    marginTop: '0px'
  }
});

const MailTemplateTitle = ({ record }) => {
  return (
    <FormTitleBar
      creation={true}
      recordLabel="Email Template"
      showAvatar
      avatarContent="ET"
    />
  );
};

// Initial template date, to send to the API,
// and avoid the error not being displayed
const initialTemplateDate = moment().toISOString();

class MailTemplateCreate extends React.Component {
  state = {
    whenBlockNavigation: false
  };

  handleFormIsDirty(dirty) {
    // Block navigation when the form is dirty
    this.setState({ whenBlockNavigation: dirty });
  }

  allowNavigationOnSave = () => {
    this.setState({ whenBlockNavigation: false });
  };

  render() {
    const { whenBlockNavigation } = this.state;
    const {
      classes,
      userProfile,
      hasDeletePermission,
      hasEditPermission,
      hasCreatePermission,
      ...rest
    } = this.props;

    return (
      <React.Fragment>
        <NavigationPrompt when={whenBlockNavigation} creation>
          {(isOpen, onConfirm, onCancel) => (
            <LeaveConfirm
              isOpen={isOpen}
              onConfirm={onConfirm}
              onClose={onCancel}
            />
          )}
        </NavigationPrompt>
        <Create
          {...rest}
          title={<MailTemplateTitle />}
          classes={{ noActions: classes.noActions }}
        >
          <CustomSimpleForm
            toolbar={
              <CreateToolbar
                allowNavigationOnSave={this.allowNavigationOnSave}
              />
            }
            variant="standard"
            margin="normal"
            initialValues={{
              templateDate: initialTemplateDate,
              editable: true,
              dynamicContent: true
            }}
          >
            <MailTemplateSummary />
            <FormSpy
              subscription={{ dirty: true }}
              onChange={props => {
                const self = this;
                setTimeout(() => self.handleFormIsDirty(props.dirty), 1);
              }}
            />
          </CustomSimpleForm>
        </Create>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(MailTemplateCreate);
